import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {adlCache$} from './adl-cache';
import type {ContractADL} from '@/types/adl';

export interface UAdl {
  type: 'adl';
  data: {
    adl: Map<string, ContractADL>;
  };
}

export function subscribeAdl() {
  adlCache$.pipe(map((adl) => ({type: 'adl', data: {adl}} as UAdl))).subscribe((msg) => toUiMsg$.next(msg));
}
